import React from 'react';
import './aboutIntro.css'; 
const AboutIntro = () => {
  return (
    <div className="about-intro">
      <h2>About Me</h2> {/* Replace with your title */}
      <p>
        {/* Briefly introduce yourself and your expertise */}
I'm a passionate software developer with 5 years of experience in the mental health industry.  Driven by the desire to empower people through technology, I leverage my entrepreneurial spirit to craft innovative solutions. My ultimate goal is to create my own company, developing products that enhance and enrich the human cognitive interface and experience.      </p>
    </div>
  );
};

export default AboutIntro;
